import React, { useEffect } from 'react'
import {
    Col,
    DatePicker,
    Row,
    Spin,
    Slider,
    Form,
    Input,
    Select,
    Table,
    InputNumber,
    Modal,
} from "antd";
import { RejectionModalTableColumns } from '../../Utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import ButtonComp from '../ButtonComp/ButtonComp';
import { CheckCircleFilled, CloseCircleFilled } from '../../Utils/imports';
import { getDynamicAdjustmentList } from '../../API-Interaction/apiServices/dynamicAdjustment.api';
import { getFromLocalStorage } from '../../Helpers/helpers';
import moment from 'moment';
import Loader from '../Helpers/Loader';
import { onRejectionSubmit, onReworkSubmit } from '../../API-Interaction/apiServices/LineOperator.api';
import NoDataFound from '../Helpers/NoDataFound';

const ReworkRejection = (props) => {
    let { handleCancel, open, type } = props
    const list = useSelector(state => state?.dynamicAdjustments?.list)
    const { line = null, machine = null } = useSelector(state => state?.plant?.current)
    const { current = null } = useSelector(state => state?.plant)
    const { username } = getFromLocalStorage('user')
    const { currentUser } = useSelector(state => state?.auth)
    const { pageLoaders } = useSelector(state => state?.utils.loaders)

    const onFinish = (values) => {
        let bodies = {
            emailOnRejection: {
                productionLineId: line?.id,
                value: values.value
            },
            logsCreate: {
                action: "Rejection Added",
                detailsAfter: { value: values.value, primary: values.ratio },
                email: username,
                hallName: current?.hall?.hallName,
                lineName: current?.line?.lineName,
                lineId: current?.line?.id,
                plantName: current?.plant?.plantName,
                machine:machine.machineName == 'default'?null:machine?.machineName,
                plantId: current?.plant?._id,
                time: moment(new Date()).toDate(),
                userId: "test132",
            },
            DYCreate: {
                createdAt: moment(new Date()).toDate(),
                lineId: current?.line?.id,
                machine: machine.machineName == 'default'?null:machine?.machineName,
                mode: "add-rejections",
                plantId: current?.plant?._id,
                value: values.value,
                primary: values.ratio,
                userEmail: username,
                _id: `DY${moment(new Date()).format(`MMDDssms`)}`
            }
        }
        console.log(bodies)
        onRejectionSubmit(bodies)
        handleCancel()
    }

    const onFinishRework = (values) => {
        let bodies = {
            emailOnRework: {
                productionLineId: line?.id,
                value: values.value
            },
            logsCreate: {
                action: "Rework Added",
                detailsAfter: { value: values.value },
                email: currentUser?.username,
                hallName: current?.hall?.hallName,
                lineName: current?.line?.lineName,
                lineId: current?.line?.id,
                plantName: current?.plant?.plantName,
                machine: machine.machineName == 'default'?null:machine?.machineName,
                plantId: current?.plant?._id,
                time: moment(new Date()).toDate(),
                userId: "test132",
            },
            DYCreate: {
                createdAt: moment(new Date()).toDate(),
                lineId: current?.line?.id,
                machine: machine.machineName == 'default'?null:machine?.machineName,
                mode: "rework",
                plantId: current?.plant?._id,
                value: values.value,
                userEmail: currentUser?.username,
                _id: `DY${moment(new Date()).format(`DDMMssms`)}`
            }
        }
        onReworkSubmit(bodies)
        handleCancel()
    }

    const onFinishFailed = (err) => {
        console.log('Falied', err)
    }


    return (
        <Modal
            width={"40%"}
            title={<h2 className="pageHead">{type === 3 ? <>Add Rejections</> : type === 4 ? <>Rework (minus from Good Count)</> : <></>}</h2>}
            open={open}
            footer={null}
            maskClosable={false}
            onCancel={handleCancel}
            mask={true}
        >
            <Form
                onFinishFailed={onFinishFailed}
                onFinish={type === 3 ? onFinish : type === 4 ? onFinishRework : () => { }}>
                <Row className="dflex alignCenter justifyCenter pb30">
                    <div style={{ width: "100%" }}>
                        <Row>
                            {line?.isTreet &&
                                <Row gutter={24}>
                                    <Col span={12}>
                                        <Form.Item className="w100">
                                            <DatePicker
                                                className="w100 boxBg boxBorderRad"
                                                placeholder="Select Date"
                                                style={{ border: "none" }}
                                                allowClear={false}

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item>
                                            <Select
                                                className="w100 boxBg boxBorderRad"
                                                placeholder="Select Shift"
                                                bordered={false}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            }
                            <Form.Item
                                label={<p className="boldText w100">VALUE</p>}
                                name="value"
                                rules={[{ required: true, message: "Please input a value!" }]}
                            >
                                <InputNumber className="boxBorderRad" />
                            </Form.Item>
                            {type === 3 && <Form.Item
                                label={<p className="boldText w100">RATIO (PRIMARY VALUE)</p>}
                                name="ratio"
                                rules={[{ required: true, message: "Please input a value!" }]}
                                className='width100P'
                            >
                                <InputNumber className="boxBorderRad" />
                            </Form.Item>}
                        </Row>
                        <Row className="dflex flexColumn">
                            <h4 className="boldText">Logs</h4>
                            <Loader loading={pageLoaders?.dynamicAdjustments}>
                                <Table
                                    dataSource={list?.length ? list.filter((data) => data?.mode === (type === 3 ? "add-rejections" : type === 4 ? "rework" : "")) : []}
                                    columns={RejectionModalTableColumns}
                                    pagination={list?.length > 9 ? true : false}
                                    locale={{
                                        emptyText: <NoDataFound />
                                    }}
                                />
                            </Loader>
                        </Row>
                    </div>
                </Row>
                <Row className="dflex alignCenter justifyCenter gap10" >
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"blue"}
                            htmlType="submit"
                            text={"Apply"}
                            icon={<CheckCircleFilled />}
                        />
                    </Form.Item>
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"red"}
                            text={"Cancel"}
                            icon={<CloseCircleFilled />}
                            onClick={handleCancel}
                        />
                    </Form.Item>
                </Row>
            </Form>
        </Modal>




    )
}

export default ReworkRejection